var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Entity',[_c('Camera',{attrs:{"type":"arcRotate","target":_vm.camPos,"alpha":_vm.alpha,"radius":_vm.radius,"beta":_vm.beta},model:{value:(_vm.myCam),callback:function ($$v) {_vm.myCam=$$v},expression:"myCam"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }